<template>
    <b-row>
        <b-col cols="12">
            <section class="padding-vertical-content">
                <div class="container">
                    <b-row>
                        <b-col cols="12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('nuevo_abono.elige_asientos') }}</h2>
                            <h3 class="subtitle h3 light mb-3">{{ $t('nuevo_abono.varios_asientos') }}</h3>
                        </b-col>
                        <b-col cols="12" lg="8" class="lightgray-content text-center p-3">
                            <ContentOrLoading style="min-height: 300px;">
                                <LeafletComponent
                                    v-if="!loading_map"
                                    :plazasSeleccionadas="butacasSeleccionadas"
                                    :svgRendered="svgRendered"
                                    :originalColor="originalColor"
                                    @isPanning="(e) => isPanning = e"
                                />
                            </ContentOrLoading>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <div class="d-flex flex-column justify-content-between" style="height: 100%;">
                                <div class="overflow-auto tusEntradas">
                                    <div 
                                        v-for="(butaca, index) in butacasSeleccionadas"
                                        class="lightgray-content p-2 mb-2"
                                        :key="index"
                                    >
                                        <div class="text-bold mb-2 d-flex justify-content-between">
                                            <div class="oswald d-flex">
                                                {{ (num = index + 1) }}. <span v-html="getButacaName(butaca)"></span>
                                            </div>
                                            <span role="button" class="oswald" @click="clickButaca(butaca.id)">
                                                <i class="fas fa-times mr-2"></i>
                                            </span>
                                        </div>
                                        <div class="form-group mb-1">
                                            <ValidationProvider
                                                :name="'precio' + index"
                                                rules="required"
                                                v-slot="{ errors }"
                                            >
                                                <select
                                                    :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                                    v-model="butaca.precioSeleccionado"
                                                    name="precio"
                                                    :disabled="bloquearPaso"
                                                >
                                                    <option :value="undefined" disabled hidden>
                                                        {{ $t("simpatizantes.selecciona_tipo_abono", {abono: 'abono'}) }}
                                                    </option>
                                                    <option
                                                        v-for="(precio, index) in butaca.precios"
                                                        :key="index"
                                                        :value="precio"
                                                    >
                                                        {{ precio.descripcion }}
                                                    </option>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <b-button 
                                        v-if="butacasSeleccionadas.length > 0" 
                                        class="btn btn-block mb-0"
                                        :disabled="bloquearPaso"
                                        @click="continuarCompra"
                                    >
                                        {{ $t('partido.continuar') }}
                                    </b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </section>
        </b-col>
    </b-row>
</template>

<script>
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';

    export default {
        props: {
            bloquearPaso: {
                type: Boolean,
                required: false,
                defaul: false
            }
        },
        data() {
            return {
                butacas: [],
                loading_map: true,
                svg: null,
                svgRendered: null,
                butacasSeleccionadas: [],
                originalColor: '#0CBA31',
                noDisponibleColor: 'gray',
                ocupadaColor: 'red',
                seleccionadaColor: '#8CA9D9',
                isPanning: false
            }
        },
        created() {
            this.getSvg();
        },
        computed: {
            recinto() {
                return this.$store.getters.getRecinto;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro
            }
        },
        methods: {
            getSvg() {
                this.loading_map = true;

                const params = {
                    filters: {},
                    recinto_id: this.recinto.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.recinto.svg'), params).then(res => {
                    this.svg = res.data.svg;
                    this.getButacas();
                }).catch(e => {
                    console.error('Error al obtener el svg general.');
                });
            },
            getButacas() {
                const params = {
                    filters: {
                        tid: this.teatro.hash
                    },
                    recinto_id: this.recinto.id,
                    lista_id: this.lista_abonados.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.butacas'), params).then(res => {
                    this.butacas = res.data.data;
                    this.renderLeafletSvg(this.svg);
                }).catch(e => {
                    console.error('Error al obtener las butacas.');
                });
            },
            renderLeafletSvg(svg) {
                const butacasFiltered = this.butacas.filter(butaca => butaca.svg_id);

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');

                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const butaca = butacasFiltered.find(butaca => butaca.svg_id == svg_id);

                    if (butaca) {
                        const title = this.getButacaName(butaca);

                        if (butaca.libre && butaca.precios.length > 0) {
                            const content = 'Disponible';
                            this.drawPopover(circle, content, title);

                            circle.style.cursor = 'pointer';
                            circle.style.transition = 'fill 0.2s'
                            circle.setAttribute('fill', this.originalColor);

                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                setTimeout(() => {
                                    if (!this.isPanning && !this.bloquearPaso) {
                                        if (!isSeleccionado) {
                                            circle.setAttribute('fill', this.seleccionadaColor);
                                            circle.setAttribute('seleccionado', 'true');
                                        } else {
                                            circle.setAttribute('fill', this.originalColor);
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickButaca(butaca.id);
                                    }
                                }, 150);
                            });
                        } else if (!butaca.disponible && butaca.precios.length > 0) {
                            this.drawPopover(circle, 'Ocupada', title);
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.ocupadaColor)
                            circle.style.fill = 'red';
                        } else {
                            this.drawPopover(circle, 'No disponible', title);
                            circle.setAttribute('no-disponible', 'true');
                            circle.setAttribute('fill', this.noDisponibleColor)
                        }
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
                this.loading_map = false;
            },
            drawPopover(circle, content, title = null) {
                const popoverOptions = {
                    html: true,
                    title: title,
                    content: content,
                    trigger: 'hover'
                }

                return new Popover(circle, popoverOptions);
            },
            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> ' + this.$t('visibilidad_reducida.nombre') + '</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            clickButaca(butacaId) {
                if (!this.bloquearPaso) {
                    this.butacas.find(butaca => {
                        if (butaca.id === butacaId && butaca.libre && butaca.precios.length > 0) {
                            butaca.seleccionada = butaca?.seleccionada && butaca.seleccionada ? false : true;
                            if (butaca.seleccionada) {
                                this.butacasSeleccionadas.push(butaca);
                                this.butacasSeleccionadas.sort((a, b) => a.butaca - b.butaca);

                            } else {
                                const index = this.butacasSeleccionadas.findIndex(butaca => butaca.id === butacaId);

                                if (index !== -1) {
                                    this.butacasSeleccionadas.splice(index, 1);
                                }
                            }
                        }
                    });
                }
            },
            continuarCompra() {
                alert('En progreso');
            }
        },
        components: {
            LeafletComponent
        }
    }
</script>